import { Controller } from '@hotwired/stimulus';

// Leaves the lobby for the webinar. Replacing the history entry lets the back
// button return to the event instead of the lobby.
export default class extends Controller {
  static values = { url: String };

  connect() {
    window.location.replace(this.urlValue);
  }
}
